(function(){
  'use strict';
  function initialise(){
    document.querySelectorAll('[data-reaction-gallery]').forEach(function(root){
      if(root.dataset.initialised)return;
      root.dataset.initialised='true';
      const track=root.querySelector('.sh-reaction-track');
      const cards=Array.from(track.children);
      const pagination=root.querySelector('[data-gallery-pagination]');
      let buttons=[];
      function buildPagination(){
        if(!cards.length)return;
        const step=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:cards[0].offsetWidth;
        const visible=Math.max(1,Math.floor((track.clientWidth+(step-cards[0].offsetWidth)+1)/step));
        const count=Math.max(1,cards.length-visible+1);
        if(buttons.length===count){updatePagination();return;}
        pagination.replaceChildren();buttons=[];
      for(let index=0;index<count;index++){
        const button=document.createElement('button');
        button.type='button';button.setAttribute('aria-label','Show reaction gallery page '+(index+1));
        button.setAttribute('aria-controls',track.id);button.setAttribute('aria-pressed',index===0?'true':'false');
        button.onclick=function(){const card=cards[index];track.scrollTo({left:card.offsetLeft-cards[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});};
        pagination.appendChild(button);buttons.push(button);
      }
      updatePagination();
      }
      let pending=false;
      function updatePagination(){
        pending=false;
        if(!cards.length)return;
        const step=cards[1]?cards[1].offsetLeft-cards[0].offsetLeft:cards[0].offsetWidth;
        let page=Math.round(track.scrollLeft/step);
        if(track.scrollLeft>0&&track.scrollLeft>=track.scrollWidth-track.clientWidth-2)page=buttons.length-1;
        buttons.forEach((button,index)=>button.setAttribute('aria-pressed',index===page?'true':'false'));
      }
      track.addEventListener('scroll',function(){if(!pending){pending=true;requestAnimationFrame(updatePagination);}}, {passive:true});
      root.querySelectorAll('.sh-reaction-play').forEach(function(button){
        const card=button.closest('.sh-reaction-card');const video=card.querySelector('video');const error=card.querySelector('.sh-reaction-error');
        button.onclick=async function(){
          button.disabled=true;error.hidden=true;
          document.querySelectorAll('audio, video').forEach(other=>{if(other!==video)other.pause();});
          try{await video.play();button.hidden=true;}
          catch{error.hidden=false;}
          finally{button.disabled=false;}
        };
        video.addEventListener('play',()=>{button.hidden=true;document.querySelectorAll('audio, video').forEach(other=>{if(other!==video)other.pause();});});
        video.addEventListener('ended',()=>{button.hidden=false;});
        video.addEventListener('error',()=>{button.hidden=false;button.disabled=false;error.hidden=false;});
      });
      buildPagination();
      if(typeof ResizeObserver==='function')new ResizeObserver(buildPagination).observe(track);
    });
  }
  initialise();document.addEventListener('shopify:section:load',initialise);
})();
